import { Pipe, PipeTransform } from '@angular/core';
import { WorkStocklocation, WorkStocklocationsV2Service } from '../_generated/work-rest-api';

@Pipe({
  name: 'getStocklocationBreadcrumb',
})
export class GetStocklocationBreadcrumbPipe implements PipeTransform {
  constructor(
    private readonly axStocklocationsV2Service: WorkStocklocationsV2Service,
  ) {
  }

  async transform(stocklocation: WorkStocklocation): Promise<string> {
    const stocklocationWithParents = await this.axStocklocationsV2Service.stocklocationsV2ControllerGetAllParentStocklocationsForId(
      { id: stocklocation.id }).toPromise();
    const stocklocationNames: string[] = [`<strong>${stocklocationWithParents.name}</strong>`];
    let currentStocklocation = stocklocationWithParents;
    while (currentStocklocation.parent && currentStocklocation.parent.name) {
      stocklocationNames.unshift(currentStocklocation.parent.name);
      currentStocklocation = currentStocklocation.parent;
    }
    return stocklocationNames.join(' → ');
  }
}
